import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Card } from "@redotech/redo-web/card";
import * as gridCss from "@redotech/redo-web/grid.module.css";
import { groupInput, input, InputProvider } from "@redotech/ui/form";
import classNames from "classnames";
import { memo } from "react";

export const tnplGeneralForm = groupInput({
  enabled: input<boolean>(),
  useMinutesForTrialPeriod: input<boolean>(),
});

export type TnplGeneralForm = InputProvider.Form<typeof tnplGeneralForm>;

export type TnplGeneralValue = InputProvider.Value<typeof tnplGeneralForm>;

export const tnplGeneralDefault: TnplGeneralValue = {
  enabled: false,
  useMinutesForTrialPeriod: false,
};

export const TnplGeneralCard = memo(function TnplGeneralCard({
  input,
}: {
  input: TnplGeneralForm;
}) {
  const { enabled, useMinutesForTrialPeriod } = input.inputs;

  return (
    <Card title="Try First">
      <section className={gridCss.grid}>
        <div className={gridCss.span12}>
          <div className={gridCss.grid}>
            <div className={classNames(gridCss.span6L, gridCss.span12)}>
              <RedoToggle
                description="Enable Try Now Pay Later (TNPL) functionality"
                label="Enabled"
                setValue={(value) => enabled.setValue(value)}
                size="sm"
                value={enabled.value ?? false}
              />
            </div>
          </div>
        </div>
        <div className={gridCss.span12}>
          <div className={gridCss.grid}>
            <div className={classNames(gridCss.span6L, gridCss.span12)}>
              <RedoToggle
                description="Use minutes instead of days for trial periods"
                label="Use minutes for trial period"
                setValue={(value) => useMinutesForTrialPeriod.setValue(value)}
                size="sm"
                value={useMinutesForTrialPeriod.value ?? false}
              />
            </div>
          </div>
        </div>
      </section>
    </Card>
  );
});
